export default __webpack_public_path__ + "static/johnathan_b-b3968299a766b8d6369380fe3f901988.png";